import React from 'react';
import { Create } from 'react-admin';
import PlotForm from './form';

const PlotCreate = (props) => {
  const { resource } = props;

  return (
    <Create title={`resources.${resource}.titles.create`} {...props}>
      <PlotForm />
    </Create>
  );
};

export default PlotCreate;
